import { MONTH_NAMES } from '../periods.js';

/* Year, then the Quarter (quarterly reports) or Month (monthly reports) to look at. The kind of period follows the report's own
 * reporting frequency, so there is no Annual / Quarterly / Monthly switch; whole-year views are on the Historic screen. */
export default function PeriodPicker({ sel, years, onChange, disabled }) {
  const set = (patch) => onChange({ ...sel, ...patch });
  return (
    <div className="toolbar periodpicker" role="group" aria-label="Choose the period to view">
      <label htmlFor="pp-year">Year</label>
      <select id="pp-year" className="ui dropdown" value={sel.year} disabled={disabled} onChange={(e) => set({ year: Number(e.target.value) })}>
        {years.map((y) => <option key={y} value={y}>{y}</option>)}
      </select>
      {sel.mode === 'quarterly' && (
        <>
          <label htmlFor="pp-quarter">Quarter</label>
          <select id="pp-quarter" className="ui dropdown" value={sel.quarter} disabled={disabled} onChange={(e) => set({ quarter: Number(e.target.value) })}>
            {[0, 1, 2, 3].map((q) => <option key={q} value={q}>Q{q + 1}</option>)}
          </select>
        </>
      )}
      {sel.mode === 'monthly' && (
        <>
          <label htmlFor="pp-month">Month</label>
          <select id="pp-month" className="ui dropdown" value={sel.month} disabled={disabled} onChange={(e) => set({ month: Number(e.target.value) })}>
            {MONTH_NAMES.map((m, i) => <option key={m} value={i}>{m}</option>)}
          </select>
        </>
      )}
    </div>
  );
}
